import { useLayoutEffect, useState, useCallback, RefObject } from "react"
import ResizeObserver from "resize-observer-polyfill"

export interface ResizeObserverEntry {
  target: HTMLElement
  contentRect: DOMRectReadOnly
}

export const useResizeObserver = (
  ref: RefObject<HTMLElement>,
  onResize?: (entry: DOMRectReadOnly) => void
) => {
  const [width, setWidth] = useState<number>(0)
  const [height, setHeight] = useState<number>(0)

  const handleResize = useCallback(
    (entries: ResizeObserverEntry[]) => {
      if (!Array.isArray(entries)) {
        return
      }

      const entry = entries[0]
      setWidth(entry.contentRect.width)
      setHeight(entry.contentRect.height)

      if (onResize) {
        onResize(entry.contentRect)
      }
    },
    [onResize]
  )

  useLayoutEffect(() => {
    if (!ref.current) {
      return
    }

    const RO = new ResizeObserver(entries => handleResize(entries))
    RO.observe(ref.current)

    return () => {
      RO.disconnect()
    }
  }, [handleResize, ref])

  return [width, height] as const
}
